export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_CONTRAST = 'SET_CONTRAST';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_LINE_HEIGHT = 'SET_LINE_HEIGHT';
